export var PeopleTurnover;
(function (PeopleTurnover) {
    PeopleTurnover[PeopleTurnover["AllDifferent"] = 1] = "AllDifferent";
    PeopleTurnover[PeopleTurnover["AlmostAllDifferent"] = 2] = "AlmostAllDifferent";
    PeopleTurnover[PeopleTurnover["HalfDifferent"] = 3] = "HalfDifferent";
    PeopleTurnover[PeopleTurnover["AlmostAllSame"] = 4] = "AlmostAllSame";
    PeopleTurnover[PeopleTurnover["AllSame"] = 5] = "AllSame";
})(PeopleTurnover || (PeopleTurnover = {}));
